import StaticPage from '@wetransfer/transfer/component/panel/content';
import Browser from '@wetransfer/transfer/modules/concorde-browser';

if (Browser.isMobile) {
  StaticPage.configure('/', (instance) => {
    instance.subscribeToStore = true;

    const iOSButton = instance.node.querySelector('#get-ios-app');
    const androidButton = instance.node.querySelector('#get-android-app');

    if (Browser.isAndroid) {
      androidButton.style.display = 'block';
    } else {
      iOSButton.style.display = 'block';
    }
  });
}
